import { useEffect, useRef } from 'react';

// export const useIsElementAtTopOfViewport = (viewportStartY = 0) => {
//   const elementRef = useRef(null);
//   const [isAtTopOfViewport, setIsAtTopOfViewport] = useState(false);

//   let setInitial = false;

//   useEffect(() => {
//     const {
//       top: initialTop,
//       height: initialHeight,
//     }: Partial<DOMRect> = (elementRef.current &&
//       (elementRef.current as any).getBoundingClientRect()) || {
//       top: undefined,
//       height: undefined,
//     };

//     if (initialTop && initialHeight && !setInitial) {
//       setIsAtTopOfViewport(
//         initialTop <= viewportStartY + 200 &&
//           initialTop >= viewportStartY - initialHeight
//       );
//       setInitial = true;
//     }
//     const onScroll = throttle(() => {
//       const {
//         top,
//         height,
//       }: DOMRect = (elementRef.current as any).getBoundingClientRect();
//       setIsAtTopOfViewport(
//         top <= viewportStartY + 200 && top >= viewportStartY - height
//       );
//     }, 300);

//     window.addEventListener('scroll', onScroll);
//     return () => window.removeEventListener('scroll', onScroll);
//   }, [elementRef]);

//   return [elementRef, isAtTopOfViewport];
// };

// Since elements aren't rendered in time for anchor links to work,
// we need to manually scroll to any anchor links on page load
export const useAnchorLinkScroll = () => {
  const hash = useRef(window.location.hash);
  useEffect(() => {
    if (hash.current && !hash.current.includes('?')) {
      (document.querySelector(hash.current) || {
        scrollIntoView: () => {}
      }).scrollIntoView();
    }
  }, []);
};